import React from "react";

import "../styles/bulma_loader.scss";
import "../styles/main.scss";

import Layout from "../components/Layout";

const IndexPage = () => {
  return (
    <Layout>
      <div className="card full-width block">
        <div className="card-content">
          <div className="content is-size-5">
            <h1 className="title" id="title">
              Hinweis
            </h1>
            <p>
              Ab dem 25.07.2026 ist auf unserem Schießstand das Schießen auf Wurftauben&nbsp;
              <strong className="is-size-5">nur mit einer Bockdoppelflinte</strong> gestattet.
            </p>
            <p>Mit freundlichen Grüßen</p>
            <p>Der Vorstand</p>
          </div>
        </div>
      </div>
      <div className="card full-width block has-text-centered">
        <div className="card-content">
          <div className="content is-size-4">
            <p>
              <form
                style={{ display: "inline" }}
                action="https://booking.sgi-flieden.de"
                method="get"
              >
                <button className="button is-link is-large is-fullwidth mb-4">
                  <span>Zu den Buchungen</span>
                </button>
              </form>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default IndexPage;
